import { Box, Breadcrumbs, Card, CardContent, FormControl, Grid2, InputLabel, MenuItem, Paper, Select, Skeleton, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Main from "../components/Main";
import AppBottomNavigation from "./../components/AppBottomNavigation";
import { Link } from "react-router-dom";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import AttachMoneyIcon from '@mui/icons-material/AttachMoneyOutlined';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';

import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import SideMenu from "../components/SideMenu";
import AppNavBar from "../components/AppNavBar";
import { fetchOverviewData } from "../services/OverviewDataService";
import { AuthContext } from "../utils/AuthContext";
import { useQuery } from "@tanstack/react-query";
import getHomeLink from "../utils/getHomeLink";
import { updateTimezone } from "../services/UsersService";

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
)


const Overview = () => {
    const { auth } = useContext(AuthContext);
    const [open, setOpen] = useState(localStorage.getItem('drawer-open') == 'true');

    const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

    // Update user's timezone
    useEffect(() => {
        const saveTimezone = async () => {
            try {
                // Get user's timezone using Intl API
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                await updateTimezone({ token: auth.token, data: { timezone } });
            } catch (error) {
                console.error('Error saving timezone:', error);
            }
        };

        saveTimezone();
    }, []);


    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    const breadcrumbs = [
        <Typography key="2" sx={{ color: 'text.primary' }}>
            Home
        </Typography>,
        <Typography key="2" sx={{ color: 'text.primary' }}>
            Overview
        </Typography>,
    ];


    const [data, setData] = useState({
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'Total Revenue Per Month',
                backgroundColor: '#3328BF',
                borderRadius: { topLeft: 5, topRight: 5 },
                data: [],
                maxBarThickness: 50
            },
        ]
    });

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            // title: {
            //     display: true,
            //     text: 'Total Revenue Per Month'
            // },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `$${tooltipItem.raw.toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`;
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value) {
                        // For axis labels, you might want to abbreviate large numbers
                        // if (value >= 1000) {
                        //     return `$${(value / 1000).toLocaleString('en-US')}k`;
                        // }
                        return `$${value.toLocaleString('en-US')}`;
                    }
                },
                // title: {
                //     display: true,
                //     text: 'Total Revenue Per Month'
                // }
            }
        }
    };

    const currentYear = new Date().getFullYear();
    const startYear = 2020;

    const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => currentYear - i);

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());




    const { data: overviewData, isFetching } = useQuery(
        {
            queryKey: ["overview_data", selectedYear, auth?.user?.id],
            queryFn: () => fetchOverviewData({ token: auth.token, year: selectedYear })
        });


    useEffect(() => {
        if (overviewData) {
            displayMonthlyRevenue(overviewData?.monthly_revenue);
        }

    }, [overviewData]);


    function displayMonthlyRevenue(monthly_revenue) {

        let monthly_revenue_array = [];

        for (let i = 0; i < 12; i++) {
            let isFound = false;
            let total = 0;

            for (let j = 0; j < monthly_revenue.length; j++) {
                if (monthly_revenue[j].month === i + 1) {
                    isFound = true;
                    total = monthly_revenue[j].total;
                    break;
                }
            }

            if (isFound) {
                monthly_revenue_array.push(total);
            } else {
                monthly_revenue_array.push(0);
            }
        }



        setData({
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [
                {
                    label: 'Total Revenue Per Month',
                    backgroundColor: '#3328BF',
                    borderRadius: { topLeft: 5, topRight: 5 },
                    data: monthly_revenue_array,
                    maxBarThickness: 50
                },
            ]
        });
    }

    const formatMoney = (value) => {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        return formatter.format(value);
    };

    return (
        <Box sx={{
            backgroundColor: '#ededed',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden', // Ensure no vertical scrollbar
        }}>
            <AppNavBar currentPage='overview' />
            <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
                <SideMenu currentPage='overview' />
                <Main
                    open={open}
                    sx={{
                        // height: '100%',
                        overflowX: 'hidden',
                        overflowY: 'scroll',
                        marginLeft: {
                            xs: 0,
                            md: 1
                        },
                        backgroundColor: '#fff',
                        mt: 7,
                        mb: 2,
                        marginRight: {
                            xs: 0,
                            md: 1
                        },
                        borderRadius: {
                            xs: 0,
                            md: 2
                        },
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        px: {
                            xs: 2,
                            md: 3
                        },
                        py: 2
                    }} >
                    <Typography variant="h1" sx={{ fontSize: 24, mb: 1 }}>
                        Overview
                    </Typography>

                    <Stack sx={{
                        display: {
                            xs: 'none',
                            md: 'block'
                        }
                    }} spacing={2}>
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            aria-label="breadcrumb"
                        >
                            {breadcrumbs}
                        </Breadcrumbs>
                    </Stack>

                    <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'end', mt: 1 }}>
                        <FormControl>
                            <InputLabel id="select-year-label">Year</InputLabel>
                            <Select
                                value={selectedYear}
                                onChange={(e) => {
                                    setSelectedYear(e.target.value);
                                }}
                                size="small"
                                label="Year"
                            >
                                {years.map((year) => (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    <Grid2 sx={{ mt: 2 }} container spacing={3} justifyContent="space-around">

                        <Grid2 size={{
                            xs: 10,
                            sm: 3
                        }}>
                            <Card elevation={2}>
                                <CardContent sx={{ position: 'relative', paddingRight: 6 }}>
                                    <Typography color="textSecondary" sx={{ position: 'absolute', top: 20, right: 8 }}>
                                        <AttachMoneyIcon />
                                    </Typography>
                                    <Typography sx={{ fontSize: 18 }} gutterBottom>
                                        Total Revenue (Annual)
                                    </Typography>
                                    <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
                                        {
                                            !overviewData || isFetching ? <Skeleton variant="rounded" width={150} height={30} />
                                                : formatMoney(overviewData?.total_annual_revenue)
                                        }

                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid2>

                        <Grid2 size={{
                            xs: 10,
                            sm: 3
                        }}>
                            <Card elevation={2}>
                                <CardContent sx={{ position: 'relative', paddingRight: 6 }}>
                                    <Typography color="textSecondary" sx={{ position: 'absolute', top: 20, right: 8 }}>
                                        <PeopleIcon />
                                    </Typography>
                                    <Typography sx={{ fontSize: 18 }} gutterBottom>
                                        Total Active Clients
                                    </Typography>
                                    <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
                                        {
                                            !overviewData ? <Skeleton variant="rounded" width={150} height={30} />
                                                : overviewData?.active_clients_count
                                        }
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid2>

                        <Grid2 size={{
                            xs: 10,
                            sm: 3
                        }}>
                            <Card elevation={2}>
                                <CardContent sx={{ position: 'relative', paddingRight: 6 }}>
                                    <Typography color="textSecondary" sx={{ position: 'absolute', top: 20, right: 8 }}>
                                        <PendingActionsOutlinedIcon />
                                    </Typography>

                                    <Typography sx={{ fontSize: 18 }} gutterBottom>
                                        Total Pending Clients
                                    </Typography>
                                    <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
                                        {
                                            !overviewData ? <Skeleton variant="rounded" width={150} height={30} />
                                                : overviewData?.pending_clients_count
                                        }
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid2>
                    </Grid2>

                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 4 }}>
                        <Box sx={{
                            height: {
                                md: '300px',
                                xs: '200px'
                            }, width: '100%', p: '10px', background: '#fff', borderRadius: '10px', boxShadow: '2px 3px 8px 5px rgba(200,200,200,0.5)',
                        }}>
                            {
                                data && options &&
                                <Bar data={data} options={options} />
                            }
                        </Box>
                    </Box>

                    {/* Bottom Navigation */}
                    <Paper sx={{
                        zIndex: 9997,
                        display: {
                            xs: 'block',
                            md: 'none'
                        }, position: 'fixed', bottom: 0, left: 0, right: 0
                    }} elevation={3}>
                        <AppBottomNavigation currentPage="overview" />
                    </Paper>
                </Main >
            </Box>
        </Box >
    );
}

export default Overview